import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { BcbService } from 'src/app/services/bcb/bcb.service';
import { ReferentielService } from 'src/app/services/referentiel/referentiel.service';
import { ReferentielEnum } from 'src/app/utils/enums/referentiel-enum';
import { Cim10 } from 'src/app/utils/interfaces/new/cim10.interface';
import { Filtres } from 'src/app/utils/interfaces/new/filtres.interface';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { RechercheBcbProduit } from 'src/app/utils/interfaces/new/recherche-bcb-produit.interface';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-search-med-nom',
  templateUrl: './search-med-nom.fragment.html',
  styleUrls: [
    './search-med-nom.fragment.scss',
    '../modal.fragment.scss'
  ]
})
export class SearchMedNomFragment implements OnInit {
  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;

  @Output() public closeEmitter = new EventEmitter();

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
      this.closeSearchMed();
    }
  }

  public selectedData: any;
  public data: any[] = [];

  public isLoadingSearch: boolean = false;
  public medBodyTable: Paginated<RechercheBcbProduit> = {
    page: 1,
    perpage: -1,
    total: 0,
    objects: []
  };
  public medColumnTable = [
    { title: 'Nom du produit', data: 'libelle' }
  ];
  public selectedMed: RechercheBcbProduit;

  constructor(
    private _bcbService: BcbService,
    private _ref: ReferentielService
  ) { }

  async ngOnInit(): Promise<void> {
    // this.isLoadingSearch = true;
    // // await this._ref.findRefListTable(ReferentielEnum.cim10)
    // await this._bcbService.getCIM10();
    // this.isLoadingSearch = false;
  }

  public async onSearchMed(event: string) {
    if (event.length >= 3) {
      await this.getSearchResult(event);
    }
  }

  public async getSearchResult(event: string) {
    this.isLoadingSearch = true;
    let resp = await this._bcbService.searchProduitByNom(event);
    if (resp && resp.length > 0) {
      for (const med of resp) {
        med['id'] = med.idProduit;
      }
    }
    this.medBodyTable.objects = resp;
    this.medBodyTable.total = this.medBodyTable.objects.length;
    this.isLoadingSearch = false;
  }

  public selectMed(obj: any) {
    this.selectedMed = obj;
    if (this.selectedData === obj) {
      this._doSelectValue({ doSelect: false, valueId: obj.id });
      this.selectedData = undefined;
    } else {
      if (this.selectedData) {
        this._doSelectValue({ doSelect: false, valueId: this.selectedData.id });
      }
      this.selectedData = obj;
      this._doSelectValue({ doSelect: true, valueId: obj.id });
    }
  }

  private _doSelectValue(value: any): void {
    if (this.medBodyTable && this.medBodyTable.objects) {
      const index = this.medBodyTable.objects.findIndex(p => p['id'] === value.valueId);
      const valueDisplayTable = this.medBodyTable.objects.find(p => p['id'] === value.valueId);

      if (value.doSelect) {
        Object.defineProperty(valueDisplayTable, 'rowColor', { configurable: true, value: 'var(--primary)' });
        Object.defineProperty(valueDisplayTable, 'textColor', { configurable: true, value: 'var(--white)' });
      } else {
        Object.defineProperty(valueDisplayTable, 'rowColor', { configurable: true, value: 'transparent' });
        Object.defineProperty(valueDisplayTable, 'textColor', { configurable: true, value: 'var(--black)' });
      }
      this.medBodyTable.objects.splice(index, 1, valueDisplayTable);
    }
  }

  public stopPropagation(event): void {
    event.stopPropagation();
  }

  public closeSearchMed(obj?: RechercheBcbProduit): void {
    this.closeEmitter.emit(obj);
  }
}
